module.exports = {"450922101":"温泉镇","450922102":"米场镇","450922103":"马坡镇","450922104":"珊罗镇","450922105":"平乐镇","450922106":"沙坡镇","450922107":"大桥镇","450922108":"乌石镇","450922109":"良田镇","450922110":"清湖镇","450922111":"古城镇","450922112":"沙湖镇","450922113":"横山镇","450922114":"滩面镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450922.json
// module id = 2264
// module chunks = 0